import createReducer from './_createReducerHelper';

export const AUTOCOMPLETE = 'autocomplete/AUTOCOMPLETE';

const initialState = {
  choices: [],
};

/** ********************************************
 * reducer
 ******************************************** */

export default createReducer(initialState, {
  [AUTOCOMPLETE]: (state, { payload }) => ({ ...state, choices: payload }),
});

/** ********************************************
 * actions
 ******************************************** */

/**
 *
 * @param choices
 * @return {{type, payload: *}}
 */
export const setAutocompleteChoices = (choices) => ({
  type: AUTOCOMPLETE,
  payload: choices,
});

/** ********************************************
 * selectors
 ******************************************** */

/**
 *
 * @param state
 */
export const readStateAutocompleteChoices = (state) => state.autocomplete.choices;
